module.exports = __webpack_public_path__ + "img/bnilogo.845ee51f.png";